/*
 * @Description: 全时空间活动服务合同（隆福寺店）
 * @Author: 杨志航
 * @Date: 2026-05-26 10:36:20
 */
import React from 'react'
import {
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Radio,
} from 'antd'
import { getNormalNumber } from '@/utils'

const FormItem = Form.Item

const TimeSpace = props => {
  const { oaidObj, accountObj, detail, form } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form

  const blurActivityServiceFee = evt => {
    const value = parseFloat(evt.target.value)
    const num = parseFloat(getFieldValue('activity_num'))
    const fee = parseFloat(getFieldValue('value_added_service_fee'))
    const total = getNormalNumber(value * num)
    if (value >= 0 && num >= 0) {
      setFieldsValue({
        'activity_service_total_fee': total
      })
      if (fee >= 0) {
        setFieldsValue({
          'activity_total_fee': getNormalNumber(total + fee)
        })
      }
    } else {
      setFieldsValue({
        'activity_service_total_fee': '',
        'activity_total_fee': ''
      })
    }
  }

  const blurActivityNum = evt => {
    const value = parseFloat(evt.target.value)
    const num = parseFloat(getFieldValue('activity_service_fee'))
    const fee = parseFloat(getFieldValue('value_added_service_fee'))
    const total = getNormalNumber(value * num)
    if (value >= 0 && num >= 0) {
      setFieldsValue({
        'activity_service_total_fee': total
      })
      if (fee >= 0) {
        setFieldsValue({
          'activity_total_fee': getNormalNumber(total + fee)
        })
      }
    } else {
      setFieldsValue({
        'activity_service_total_fee': '',
        'activity_total_fee': ''
      })
    }
  }

  const blurValueAddedServiceFee = evt => {
    const value = parseFloat(evt.target.value)
    const num = parseFloat(getFieldValue('activity_service_total_fee'))
    if (value >= 0 && num >= 0) {
      setFieldsValue({
        'activity_total_fee': getNormalNumber(value + num)
      })
    } else {
      setFieldsValue({
        'activity_total_fee': ''
      })
    }
  }

  return (
    <>
      <div className="line"></div>
      <h3 className="apply-tit">双方公司信息及联系方式</h3>
      <div className="underline"></div>
      <Row gutter={24}>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>甲方（委托方）</div>
        </Col>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>乙方（服务提供方）</div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{oaidObj.name ? oaidObj.name : detail.partA}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="统一社会信用代码/身份证号" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <div>{oaidObj.verifyNumber}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="统一社会信用代码/身份证号" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <div>91110101MAE0T9NP6D</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Aaddress', {
              rules: [{ required: true, message: '请输入甲方联系地址' }]
            })(<Input placeholder="请输入甲方联系地址" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="地址" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>北京市东城区隆福寺街6号院1号楼2层EL2-21号商铺</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="法定代表人/负责人" labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Acontacts', {
              rules: [{ required: true, message: '请输入甲方法定代表人/负责人' }]
            })(<Input placeholder="请输入甲方法定代表人/负责人" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="法定代表人/负责人" labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Bcontacts', {
              rules: [{ required: true, message: '请输入乙方法定代表人/负责人' }]
            })(<Input placeholder="请输入乙方法定代表人/负责人" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Atel', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="联系电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Btel', {
              rules: [{ required: true, message: '请输入乙方联系电话' }]
            })(<Input placeholder="请输入乙方联系电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="电子邮箱" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Aemail', {
              rules: [{ required: true, message: '请输入甲方电子邮箱' }]
            })(<Input placeholder="请输入甲方电子邮箱" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="电子邮箱" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Bemail', {
              rules: [{ required: true, message: '请输入乙方电子邮箱' }]
            })(<Input placeholder="请输入乙方电子邮箱" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="项目经理姓名" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('Bmanager', {
              rules: [{ required: true, message: '请输入乙方项目经理姓名' }]
            })(<Input placeholder="请输入乙方项目经理姓名" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
        </Col>
        <Col span={12}>
          <FormItem label="项目经理电话" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('BmanagerTel', {
              rules: [{ required: true, message: '请输入乙方项目经理电话' }]
            })(<Input placeholder="请输入乙方项目经理电话" style={{ width: 240 }} maxLength={100} />)}
          </FormItem>
        </Col>
      </Row>
      <div className="line"></div>
      <h3 className="apply-tit" style={{ marginTop: '40px' }}>活动费用与开票信息</h3>
      <div className="underline" style={{ marginBottom: '16px' }}></div>
      <Row gutter={24}>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>活动费用：</div>
        </Col>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>甲方开票信息：</div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="本活动服务费用（含税）" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('activity_service_fee', {
              rules: [{ required: true, message: '请填写保留两位小数的正数或零' }]
            })(<InputNumber 
              placeholder="请填写保留两位小数的正数或零" 
              precision={2} style={{ width: 240 }} 
              onBlur={blurActivityServiceFee} 
              min={0}
            />)}
            <span style={{paddingLeft: '10px'}}>元/人</span>
          </FormItem>
        </Col>
        <Col span={12}>
          <Form.Item label="发票类型" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('invoice_type', {
              rules: [{ required: true, message: '请选择发票类型' }]
            })(
              <Radio.Group>
                <Radio value="1">增值税专用发票</Radio>
                <Radio value="2">增值税普通发票</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="本活动参加人数" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('activity_num', {
              rules: [{ required: true, message: '请填写正整数' }]
            })(<InputNumber 
              placeholder="请填写正整数" 
              precision={0} 
              style={{ width: 240 }} 
              onBlur={blurActivityNum} 
              min={0}
            />)}
            <span style={{paddingLeft: '10px'}}>位</span>
          </FormItem>
        </Col>
        <Col span={12}>
          <Form.Item label="发票内容" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('invoice_content', {
              rules: [{ required: true, message: '请选择发票内容' }]
            })(
              <Radio.Group>
                <Radio value="1">*现代服务*服务费*</Radio>
                <Radio value="2">*会展服务*会议费</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="本活动服务总费用" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} required>
            {getFieldDecorator('activity_service_total_fee')
            (<InputNumber className="no-style-input" precision={2} style={{ width: 240 }} disabled />)}
            <span style={{paddingLeft: '10px'}}>元</span>
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="增值服务费用" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('value_added_service_fee', {
              rules: [{ required: true, message: '请填写保留两位小数的正数或零' }]
            })(<InputNumber 
              placeholder="请填写保留两位小数的正数或零" 
              precision={2} 
              style={{ width: 240 }} 
              onBlur={blurValueAddedServiceFee} 
              min={0}
            />)}
            <span style={{paddingLeft: '10px'}}>元/场</span>
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="本活动总费用" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} required>
            {getFieldDecorator('activity_total_fee')
            (<InputNumber className="no-style-input" precision={2} style={{ width: 240 }} disabled />)}
            <span style={{paddingLeft: '10px'}}>元</span>
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
    </>
  )
}

export default TimeSpace